import type { FC, PropsWithChildren } from 'react'
import type { CheckboxProps } from 'antd'

import { SC_Checkbox } from './styled'

export type T_CheckboxProps = CheckboxProps

export const Checkbox: FC<PropsWithChildren<T_CheckboxProps>> = ({
  children,
  ...restProps
}) => {
  return (
    <SC_Checkbox {...restProps}>
      {children}
    </SC_Checkbox>
  )
}
